import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LimiterDirective } from '../../directive/limiter';

@Component({
  selector: 'msh-form-input-number',
  imports: [FormsModule, LimiterDirective],
  template: `
  
      <div class="relative">
        <input
          class=" absolute focus:opacity-100 opacity-0 w-full "
          type="number"
          [placeholder]="placeholder"
          [(ngModel)]="price"
          pattern="^\d*(\.\d{2})?$"
          min="0"
          limiter
          [maxValue]="limiterValue || 1000"
          name="price"
          (keyup)="immediatePriceChange($event)"
          (blur)="priceChange($event)"
          required
        />
        <input
          type="text"
          [placeholder]="placeholder"
          [(ngModel)]="displayPrice"
          name="displayPrice"
          required
        />
      </div>
  `,
  styles: ``
})
export class FormInputNumberComponent implements OnChanges {
// FIXME Deal with undefined
  @Input() allowDisplayZero?: boolean;
  @Input() placeholder!: string;
  @Input() price?: number;
  @Input() limiterValue?: number;
  @Output() onImmediatePriceChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() onPriceChange: EventEmitter<number> = new EventEmitter<number>();
  displayPrice = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['price'] ) {
      if(!this.price || this.price === undefined || this.price === null){
        this.price = 0
      }
      this.displayPrice = (this.allowDisplayZero || this.price !== 0 ) ? '$'+this.price?.toFixed(2) : this.placeholder;
    }
  }
  priceChange(ev: any){
    if(this.price && this.price !== undefined && this.price !== null){ 
      this.displayPrice = '$'+this.price.toFixed(2); // TODO: also add commas
    }
    this.onPriceChange.emit(this.price);
  }
  immediatePriceChange(ev: any){
    this.onImmediatePriceChange.emit(this.price);
  }
}
